import { ApolloError } from '@apollo/client';

// eslint-disable-next-line max-len
export const useApolloErrorHandler = (isSignedIn: () => boolean, error?: ApolloError) => {
  if (!error) {
    return;
  }
  isSignedIn();
};
